import { Chip } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'

const Curriculum = () => {
  const curriculum = useSelector((state) => state?.assessment?.curriculum || [])
  return (
    <div className='section-curriculum absolute bottom-0'>
      <div className='section-curriculum flex wrap gap-2 justify-center items-center'>
        {curriculum.map((item, index) => (
          <Chip size='small' key={index} label={item.shortName} />
        ))}
      </div>
    </div>
  )
}

export default Curriculum